(function () {
  'use strict';

  /**
   * @ngdoc object
   *
   *
   * @description
   *
   */
angular
    .module('crewProfile')
    .controller('CrewSecondaryBaseHistoryController', CrewSecondaryBaseHistoryController);

    function CrewSecondaryBaseHistoryController($uibModalInstance, modalParams, ProfileService) {
        var vm = this;

        vm.model = {
            crewSecondaryBaseAssignments : []
        };

        function getCrewSecondaryBaseAssignmentData() {
            var param = {};
            param.crewProfileId = modalParams.crewProfileId;
            param.primary = false;
            ProfileService.getAllCrewBaseAssignmentData(param,
                function (response) {
                    vm.model.crewSecondaryBaseAssignments = response;
                },
                function (error) {
                    console.log('Crew secondary base assignment data retrieval error')
                }
            );
        }

        vm.closeMe = function () {
            $uibModalInstance.close();
        };

        getCrewSecondaryBaseAssignmentData();
    }
}());
